import MissionTile from '@/components/homepage/MissionTile';
import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';

export default function MissionTileBuilder({
  backgroundColor,
  title,
  iconTextColor,
  icons,
  description,
  ctaColor,
  ctas,
  anchorLinkID,
  isSetMaxWidth,
  isFullBleed,
  margin,
}) {
  return (
    <div className={getComponentMargin(margin)} {...getAnchorId(anchorLinkID)}>
      <MissionTile
        backgroundColor={backgroundColor}
        title={title}
        iconTextColor={iconTextColor}
        icons={icons}
        description={description}
        ctaColor={ctaColor}
        ctas={ctas}
        isSetMaxWidth={isSetMaxWidth}
        isFullBleed={isFullBleed}
      />
    </div>
  );
}
